import React, {useState} from 'react';
import {Button, Row, Col, Modal, FormGroup, Label} from 'reactstrap';
import {useForm} from 'react-hook-form';
import authHeader from '../../helpers/jwt-token-access/auth-token-header';
import {SweetAlert} from '../Common/SweetAlert';
import {useNavigate} from 'react-router-dom';
import Moment from 'react-moment';
import axios from 'axios';

const reasonList = [
  {label: 'Good will', value: '1'},
  {label: '3 months', value: '2'},
  {label: 'Other', value: '3'},
];

const problemList = [
  {label: 'Mech:Maintenance unit broken', value: 'Mech:Maintenance unit broken'},
  {label: 'Mech:Cartridge broken', value: 'Mech:Cartridge broken'},
  {label: 'Mech:Ink supply area broken', value: 'Mech:Ink supply area broken'},
  {label: 'Mech:Tube broken', value: 'Mech:Tube broken'},
  {label: 'Mech:Platen broken', value: 'Mech:Platen broken'},
  {label: 'Mech:Cover broken', value: 'Mech:Cover broken'},
  {label: 'Mech:Cariage broken', value: 'Mech:Cariage broken'},
  {label: 'Mech:Motor broken', value: 'Mech:Motor broken'},
  {label: 'Mech:Other', value: 'Mech:Other'},
  {label: 'Head:Missing', value: 'Head:Missing'},
  {label: 'Head:Angled Firing', value: 'Head:Angled Firing'},
  {label: 'Head:Both', value: 'Head:Both'},
  {label: 'Head:CLP peeling off', value: 'Head:CLP peeling off'},
  {label: 'Head:Nozzle plate peeling off', value: 'Head:Nozzle plate peeling off'},
  {label: 'Head:Temp, voltage abnormal', value: 'Head:Temp, voltage abnormal'},
  {label: 'Head:Other', value: 'Head:Other'},
  {label: 'App/Firm:Other', value: 'App/Firm:Other'},
  {label: 'Ink:Ink pouch burst', value: 'Ink:Ink pouch burst'},
  {label: 'Ink:IC chip missing', value: 'Ink:IC chip missing'},
  {label: 'Sub:Main PCB broken', value: 'Sub:Main PCB broken'},
  {label: 'Sub:Carriage PCB broken', value: 'Sub:Carriage PCB broken'},
  {label: 'Sub:Ink Switch PCB broken', value: 'Sub:Ink Switch PCB broken'},
  {label: 'Sub:Other', value: 'Sub:Other'},
  {label: 'Other:Other', value: 'Other:Other'},
];

const ModalFinalCheck = ({claim}) => {
  const [modalOpen, setModalOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [alert, setAlert] = useState({type: '', message: '', show: false});

  const navigate = useNavigate();
  const {
    register,
    handleSubmit,
    watch,
  } = useForm({
    mode: 'onChange',
    values: {
      status: String(claim.internal_check_status),
      problem_type: claim.problem_type || '',
      reason_choice: claim.reason_choice || '',
      other_reason: claim.other_reason || '',
      individual_reply: claim.individual_reply || '',
    },
  });

  const watchedStatus = watch('status');
  const watchedReason = watch('reason_choice');

  const toggleModal = () => setModalOpen(!modalOpen);

  const sendFinalCheck = async (finalCheck) => {
    setLoading(true);
    try {
      const url = `${process.env.REACT_APP_APIURL}claim/finalcheck`;
      const authToken = authHeader();

      const formData = new FormData();
      formData.append('data', JSON.stringify(finalCheck));

      await axios.post(url, formData, {headers: authToken});
      setAlert({type: 'success', message: 'Final check submitted successfully', show: true});
    } catch (error) {
      setAlert({type: 'error', message: 'There was an error submitting the request', show: true});
    } finally {
      setLoading(false);
    }
  };

  const onSubmit = (values) => {
    const reason =
      values.reason_choice === '3' ? values.other_reason : reasonList.find((r) => r.value === values.reason_choice)?.label || '';

    const finalCheck = {
      claim_id: claim.id,
      status: values.status,
      individual_reply: values.status === '3' ? (values.individual_reply || '') : '',
      reason_choice: values.reason_choice || '',
      reason: reason,
      problem_type: values.problem_type || '',
    };

    sendFinalCheck(finalCheck);
  };

  return (
    <>
      <Button
        color="dark"
        onClick={toggleModal}
        disabled={claim.internal_check_status === 0 || claim.final_check_status > 0}
      >
        Warranty Check
      </Button>

      <Modal size="lg" isOpen={modalOpen} toggle={toggleModal} centered>
        <div className="modal-body">
          <button type="button" className="close" onClick={toggleModal} aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>

          <Row>
            <Col md={1}>
              <div className="avatar-sm">
                <span className="avatar-title rounded-circle bg-primary text-white">
                  <i className="bx bx-check-circle bx-sm"/>
                </span>
              </div>
            </Col>

            <Col md={11}>
              <h5>Warranty Check</h5>
              <p>Please choose from the following cases</p>

              <div className="mb-3">
                <strong>Internal Checked</strong>
                <div className="bg-yellow p-1 d-flex mt-2">
                  <span className="align-self-center mr-1">
                    <i className="bx bx-check-circle bx-sm"/>
                  </span>
                  <span className="align-self-center">
                    On <strong><Moment format="DD-MM-YYYY">{claim.internal_check_date}</Moment></strong> by{' '}
                    <strong>{claim.internal_check_user.firstname} {claim.internal_check_user.lastname}</strong>
                  </span>
                </div>
              </div>

              <form onSubmit={handleSubmit(onSubmit)}>
                <Row className={'mb-3'}>
                  <Col>
                    <input
                      type="radio"
                      value="1"
                      {...register('status', {
                        required: true,
                      })}
                    /> Warranty accepted
                  </Col>
                  <Col>
                    <input
                      type="radio"
                      value="2"
                      {...register('status', {
                        required: true,
                      })}
                    /> Internal accepted
                  </Col>
                  <Col>
                    <input
                      type="radio"
                      value="3"
                      {...register('status', {
                        required: true,
                      })}
                    /> Warranty not granted
                  </Col>
                </Row>

                {watchedStatus && (
                  <Row>
                    <Col md={6}>
                      <FormGroup>
                        <Label className="col-form-label">Customer</Label>
                        <input type="text" value={claim.customer?.name || ''} disabled className="form-control"/>
                      </FormGroup>
                    </Col>
                    <Col md={6}>
                      <FormGroup>
                        <Label className="col-form-label">Dealer</Label>
                        <input type="text" value={claim.dealer?.name || ''} disabled className="form-control"/>
                      </FormGroup>
                    </Col>

                    {watchedStatus === '1' && (
                      <Col md={6}>
                        <Label className="col-form-label">Problem</Label>
                        <select {...register('problem_type', {
                          required: true,
                        })} className="form-control">
                          <option value="">Select problem</option>
                          {problemList.map((p, i) => <option key={i} value={p.value}>{p.label}</option>)}
                        </select>
                      </Col>
                    )}
                    {watchedStatus === '2' && (
                      <Col md={6}>
                        <Label className="col-form-label">Reason</Label>
                        <select {...register('reason_choice')} className="form-control">
                          <option value="">Select reason</option>
                          {reasonList.map((r) => <option key={r.value} value={r.value}>{r.label}</option>)}
                        </select>
                        {watchedReason === '3' && (
                          <input {...register('other_reason')} type="text" className="form-control mt-2" placeholder="Other reason"/>
                        )}
                      </Col>
                    )}
                    {watchedStatus === '3' && (
                      <Col md={12}>
                        <Label className="col-form-label">Message</Label>
                        <textarea
                          {...register('individual_reply')}
                          className="form-control"
                          rows={5}
                          defaultValue={['bma'].includes(process.env.REACT_APP_REALM) ?
                            `Dear ${claim.engineer.firstname} ${claim.engineer.lastname},\n\nWe checked the parts and we have unfortunately inform you that we are unable to confirm your claim. Should you require further information please do not hesitate to contact us via e-mail to ipb-support@brother-ism.com. Please use the Fault Report Number in the subject.` :
                            `Dear ${claim.engineer.firstname} ${claim.engineer.lastname},\n\nWe checked the parts and we have unfortunately inform you that we are unable to confirm your claim.\nShould you require further information do not hesitate to contact us via e-mail.\nPlease use the Fault Report Number in the subject.`}
                        />
                      </Col>
                    )}
                  </Row>
                )}

                <Row className="mt-2">
                  <Col md={8}>
                    <p>
                      When you submit it, the status of the claim is changed and the customer is informed.
                      In the &#34;Warranty accepted&#34; case, the case is transferred to Salesforce.
                    </p>
                  </Col>
                  <Col md={4} className="text-sm-right">
                    <Button color="yellow" type="submit" disabled={loading}>
                      {loading && <i className="bx bx-loader bx-spin mr-2"/>}
                      {watchedStatus === '1' ? 'Send to Salesforce' : 'Final Warranty Check'}
                    </Button>
                  </Col>
                </Row>
              </form>
            </Col>
          </Row>
        </div>
      </Modal>

      {alert.show && (
        <SweetAlert
          title={alert.type === 'success' ? 'Good job!' : 'Request could not be submitted!'}
          success={alert.type === 'success'}
          warning={alert.type === 'error'}
          onConfirm={() => {
            setAlert({...alert, show: false});
            if (alert.type === 'success') navigate('/claims');
          }}
        >
          {alert.message}
        </SweetAlert>
      )}
    </>
  );
};

export default ModalFinalCheck;
